import { initialState } from './initial';
import { reducers } from './reducers';

export const showMessageSegment = {
  initialState,
  reducers,
};
